export default __webpack_public_path__ + "MBD_Impressum_Stand_11-2025.pdf";